<template>
  <div class="card bg-light border-danger">
    <div class="card-header" id="headingOne">
      <h5 class="mb-0">
        <span class="btn btn-secondary">
          Registrar Porcentajes General Calificación
          <span
            v-if="form.estado_porcentaje_calificacion == 2"
            class="badge badge-success"
            >Definitivo</span
          >
          <span v-else class="badge badge-danger">Borrador</span>
        </span>
        <span
          class="badge bg-gradient-primary shadow-sm ml-2"
          :class="
            val_total_porcentaje == 100
              ? 'bg-gradient-success'
              : 'bg-gradient-warning'
          "
        >
          {{ Number(val_total_porcentaje).toFixed(2) }}%
        </span>
      </h5>
      <div class="card-body">
        <div class="row" v-if="form.estado_porcentaje_calificacion != 2">
          <!-- Campo item de calificacion -->
          <div class="col-md-3">
            <div class="form-group">
              <label for="item_evaluaciones">Items de evaluacion</label>
              <select
                class="form-control form-control-sm"
                v-model="form_porcentajes.tipo_calificacion"
                @change="changeTipoCalificacion()"
                :disabled="definitivo == 1"
                :class="
                  $v.form_porcentajes.tipo_calificacion.$invalid
                    ? 'is-invalid'
                    : 'is-valid'
                "
              >
                <option value="0">OTRO</option>
                <option
                  v-for="items in listasForms.itemsEvaluacion"
                  :key="items.id"
                  :value="items.numeracion"
                >
                  {{ items.descripcion }}
                </option>
              </select>
            </div>
          </div>
          <!-- /.Campo item de calificacion-->
          <!-- campo oculto de nombre personalizado -->
          <div class="col-md-3" v-if="form_porcentajes.tipo_calificacion == 0">
            <div class="form-group">
              <label for="item_evaluaciones">Nombre</label>
              <input
                :disabled="definitivo == 1"
                type="text"
                class="form-control form-control-sm shadow-sm"
                id="nombre"
                v-model="form_porcentajes.nombre"
                :class="
                  $v.form_porcentajes.nombre.$invalid
                    ? 'is-invalid'
                    : 'is-valid'
                "
              />
            </div>
          </div>
          <!-- /. campo oculto de nombre personalizado -->
          <!-- Campo Signo -->
          <div class="col-md-3">
            <label for="item_evaluaciones">Signo</label>
            <div class="input-group">
              <select
                :disabled="definitivo == 1"
                type="number"
                class="form-control form-control-sm shadow-sm"
                id="signo"
                v-model="form_porcentajes.signo"
                :class="
                  $v.form_porcentajes.signo.$invalid ? 'is-invalid' : 'is-valid'
                "
              >
                <option value="">seleccione...</option>
                <option value="1">➕ Positivo</option>
                <option value="2">➖ Negativo</option>
              </select>
              <div class="input-group-append">
                <span class="input-group-text form-control-sm">%</span>
              </div>
            </div>
          </div>
          <!-- Campo Porcentaje -->
          <div class="col-md-3">
            <label for="item_evaluaciones">Porcentaje</label>
            <div class="input-group">
              <input
                :disabled="definitivo == 1"
                type="number"
                class="form-control form-control-sm shadow-sm"
                id="porcentaje"
                v-model="form_porcentajes.porcentaje"
                :class="
                  $v.form_porcentajes.porcentaje.$invalid
                    ? 'is-invalid'
                    : 'is-valid'
                "
              />
              <div class="input-group-append">
                <span class="input-group-text form-control-sm">%</span>
              </div>
            </div>
          </div>
          <!-- /.Campo Porcentaje -->
          <!-- Boton de registro -->
          <div class="col-md-3 p-1">
            <div class="form-group">
              <button
                :disabled="definitivo == 1"
                v-show="
                  !$v.form_porcentajes.$invalid &&
                  form.estado_porcentaje_calificacion != 2
                "
                @click="saveProcentajeCalificacion"
                class="btn bg-gradient-primary mt-4 shadow-sm"
              >
                <i class="fas fa-paper-plane"></i> Guardar
              </button>
            </div>
          </div>
          <!-- /. Boton de registro -->
        </div>
        <!-- TABLA PORCENTAJES -->
        <div>
          <table
            class="table table-sm table-striped table-bordered table-hover rounded overflow-hidden text-center"
          >
            <thead class="bg-primary text-white text-center">
              <tr>
                <th scope="col" class="align-middle">
                  <i class="fas fa-tags mr-2"></i>
                  Item a calificar
                </th>
                <th scope="col" class="align-middle">
                  <i class="fas fa-calculator mr-2"></i>
                  Signo
                </th>
                <th scope="col" class="align-middle">
                  <i class="fas fa-percent mr-2"></i>
                  Porcentaje
                </th>
                <th scope="col" class="align-middle">
                  <i class="fas fa-cogs mr-2"></i>
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in porcentajes_calificacion" :key="item.id">
                <td v-if="item.tipo_calificacion == 0">
                  {{ item.nombre }}
                </td>
                <td v-else>{{ item.nomItemEvaluado }}</td>
                <td>
                  <h5>
                    <span
                      v-if="item.signo"
                      class="badge shadow"
                      :class="
                        item.signo == 1
                          ? 'bg-gradient-success'
                          : 'bg-gradient-danger'
                      "
                    >
                      <i v-if="item.signo == 1" class="fas fa-plus-circle"></i>
                      <i
                        v-else-if="item.signo == 2"
                        class="fas fa-minus-circle"
                      ></i>
                    </span>
                  </h5>
                </td>
                <td>
                  <h5>
                    <span class="badge bg-gradient-success shadow">
                      {{ Number(item.porcentaje).toFixed(2) }}%
                    </span>
                  </h5>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    v-on:click="destroyPorcentaje(item.id)"
                    v-if="
                      $store.getters.can(
                        'hidrocarburos.porcentajesCalificaciones.delete'
                      ) && form.estado_porcentaje_calificacion == 1
                    "
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                  <span
                    v-if="form.estado_porcentaje_calificacion == 2"
                    class="mx-2 text-muted"
                  >
                    <i class="fas fa-lock"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Boton para cambiar estado de la calificacion general -->
        <div class="">
          <button
            type="button"
            :disabled="definitivo == 1"
            class="btn bg-gradient-primary shadow-sm"
            v-if="
              val_total_porcentaje == 100 &&
              form.estado_porcentaje_calificacion == 1
            "
            v-on:click="saveEstadoPorcentaje()"
          >
            <i class="fa fa-share-square"></i> Guardar Porcentajes General
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import axios from "axios";

export default {
  name: "PorcentajesGeneral",
  props: {
    form: {
      type: Object,
      required: true,
    },
    definitivo: {
      type: Number,
      default: 0,
    },
    porcentajes_calificacion: {
      type: Array,
      default: () => [],
    },
    val_total_porcentaje: {
      type: Number,
      default: 0,
    },
    listasForms: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form_porcentajes: {
        tipo_calificacion: "",
        nombre: "",
        signo: null,
        porcentaje: "",
        calificacion_id: null,
      },
    };
  },

  validations() {
    let nombre_calificacion = this.form_porcentajes.nombre;
    if (this.form_porcentajes.tipo_calificacion == 0) {
      nombre_calificacion = { required };
    } else {
      nombre_calificacion = { required: false };
    }
    return {
      form_porcentajes: {
        tipo_calificacion: { required },
        nombre: nombre_calificacion,
        porcentaje: {
          required,
          /*  minValue: minValue(0.00), */ maxValue: maxValue(100),
        },
        signo: { required },
      },
    };
  },

  methods: {
    saveProcentajeCalificacion() {
      //variable para capturar el valor de los porcentajes
      var total_porcentaje = 0;
      var itemDuplicado = false;
      var porcentajeSuperado = false;
      //valida solo campos del control list
      if (this.form_porcentajes.tipo_calificacion == 0) {
        //valido todos los campos
        this.form_porcentajes.nombre =
          this.form_porcentajes.nombre.toUpperCase();
        //valida duplicados
        for (let i = 0; i < this.porcentajes_calificacion.length; i++) {
          total_porcentaje =
            total_porcentaje +
            Number(this.porcentajes_calificacion[i].porcentaje);
        }
      } else {
        //valido todos los campos
        this.form_porcentajes.nombre = this.listasForms.itemsEvaluacion.find(
          (element) =>
            element.numeracion == this.form_porcentajes.tipo_calificacion
        ).descripcion;
        for (let a = 0; a < this.porcentajes_calificacion.length; a++) {
          total_porcentaje =
            total_porcentaje +
            Number(this.porcentajes_calificacion[a].porcentaje);
        }
      }

      //validar duplicado
      let duplicado = this.porcentajes_calificacion.find(
        (element) => element.nombre == this.form_porcentajes.nombre
      );

      if (duplicado != undefined) {
        this.$swal({
          icon: "error",
          title: "El item ya se encuentra agregado!",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        itemDuplicado = true;
        this.form_porcentajes.porcentaje = null;
        this.form_porcentajes.tipo_calificacion = null;
      }
      //se suma el total de porcentajes agregados
      total_porcentaje =
        total_porcentaje + Number(this.form_porcentajes.porcentaje);

      if (total_porcentaje > 100) {
        this.$swal({
          icon: "error",
          title: "El total de porcentajes no puede superar el 100%",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        porcentajeSuperado = true;
        this.form_porcentajes.porcentaje = null;
      }
      //se validad si las validades fueron superadas
      if (itemDuplicado == false && porcentajeSuperado == false) {
        //realiza envio
        this.form_porcentajes.calificacion_id = this.form.id;
        axios({
          method: "POST",
          url: "/api/hidrocarburos/Porcentajescalificaciones",
          data: this.form_porcentajes,
        })
          .then((response) => {
            this.$swal({
              icon: "success",
              title: "la seccion se guardo exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.form_porcentajes.signo = null;
            this.form_porcentajes.porcentaje = null;
            this.form_porcentajes.tipo_calificacion = null;
            this.form_porcentajes.nombre = null;
            this.$parent.init();
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    destroyPorcentaje(id) {
      this.$swal({
        title: "Esta seguro de eliminar este item de porcentaje?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        // <--
        if (result.value) {
          axios
            .delete("/api/hidrocarburos/Porcentajescalificaciones/" + id)
            .then((response) => {
              this.$parent.init();
              this.$swal({
                icon: "success",
                title: "Se elimino la seccion de manera exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    saveEstadoPorcentaje() {
      this.$swal({
        title: "Desea registra la informacion?",
        text: "Recuerde que una vez registrados los porcentajes no se podran revertir los cambios!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Registrar!",
        cancelButtonText: "No, Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          axios({
            method: "PUT",
            url: "/api/hidrocarburos/Porcentajescalificaciones",
            data: this.form,
          })
            .then((response) => {
              this.$parent.init();
              this.$swal({
                icon: "success",
                title: "los porcentajes se guardaron exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.$swal(
                "Agregado!",
                "Los porcentajes han sido grabados.",
                "success"
              );
            })
            .catch((e) => {
              this.$swal({
                icon: "error",
                title: "Ocurrio un error, vuelva a intentarlo..." + e,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    changeTipoCalificacion() {
      this.form_porcentajes.nombre = null;
      this.form_porcentajes.porcentaje = null;
    },
  },
};
</script>
